'use client';

import { Align, DirectionEnum, FlexBox, FlexItem, Image, RadioTile, RadioTiles, Text } from '@bytel/trilogy-react';

import { Connectivity, PlanType } from '@app-types/product';

import { useHome } from '@landing/hooks';

export function DataList({
    plans,
    isMobileFirst,
    selectedGencode,
}: Readonly<{
    plans: PlanType[];
    isMobileFirst: boolean;
    selectedGencode?: string;
}>) {
    const { selectedOption, setSelectedPlan, setSelectedNetwork, setTemporarilySelectedPlan } = useHome();

    const onChange = (plan: PlanType) => {
        if (plan.option5g && Object.values(plan.option5g).length === 0) {
            setSelectedNetwork(Connectivity.FIVE_G);
        } else if (!selectedOption) {
            setSelectedNetwork(Connectivity.FOUR_G);
        }
        if (isMobileFirst) {
            setSelectedPlan(plan);
        } else {
            setTemporarilySelectedPlan(plan);
        }
    };
    const sortedPlans = [...plans]?.sort((a, b) => a.dataSize - b.dataSize);
    const plansWithSubtitleAndImage = sortedPlans.filter(
        (plan) => plan.bundle_subtitle_roaming && plan.bundle_image?.public_url,
    );
    const standardPlans = sortedPlans.filter(
        (plan) => !(plan.bundle_subtitle_roaming && plan.bundle_image?.public_url),
    );
    const displayedPlans = [...plansWithSubtitleAndImage, ...standardPlans];

    return (
        <RadioTiles className='grid-radio-list'>
            {displayedPlans.map((plan) => {
                const isSelected = plan.gencode === selectedGencode;
                const hasSubtitleAndImage = Boolean(plan.bundle_subtitle_roaming && plan.bundle_image);

                return (
                    <RadioTile
                        key={plan.gencode}
                        onChange={() => onChange(plan)}
                        checked={isSelected}
                        horizontal
                        label={hasSubtitleAndImage ? undefined : plan.dataEnvelope}
                        value={plan.gencode}
                        id={plan.gencode}
                        sticker={plan.radioFlag}
                        stickerVariant={plan.radioFlagColor}
                        className={hasSubtitleAndImage ? 'radio-tile-full-width' : 'radio-tile-text-wrap'}
                        {...(hasSubtitleAndImage
                            ? {
                                  description: (
                                      <FlexBox wrap direction={DirectionEnum.ROW} align={Align.CENTER}>
                                          <FlexItem>
                                              <span className='radio-title'>{plan.dataEnvelope}</span>
                                              <span className='radio-tile-description'>
                                                  <Text markup='span' className='radio-tile-subtitle'>
                                                      {plan.bundle_subtitle_roaming}
                                                  </Text>
                                              </span>
                                          </FlexItem>
                                          <FlexItem narrow>
                                              <Image
                                                  src={plan.bundle_image!.public_url}
                                                  alt={plan.bundle_image?.title ?? ''}
                                                  className='radio-tile-image'
                                              />
                                          </FlexItem>
                                      </FlexBox>
                                  ),
                              }
                            : {})}
                    />
                );
            })}
        </RadioTiles>
    );
}
